/**
 * If the user doesn't have the legacy auth cookie, we send them to the login page.
*/
const authenticated = ({
    app,
    redirect,
    route,
    store
}) => {
    const { settings } = store.state.configuration;
    const { legacyCookieName, oneWebCookieName } = settings.auth;
    const legacyAuthCookie = app.$cookies.get(legacyCookieName);
    const oneWebAuthCookie = app.$cookies.get(oneWebCookieName);

    if (!legacyAuthCookie && !oneWebAuthCookie) {
        const currentEncodedUrl = encodeURIComponent(route.fullPath);

        redirect(`/account/login?returnUrl=${currentEncodedUrl}`);
    }
};

export default authenticated;
